const empty = value => value === null || value === undefined || String(value).trim() === ''
const code = value => value && typeof value === 'object' ? value.code : value
const label = value => value && typeof value === 'object' ? value.name || value.code || '' : empty(value) ? '' : value
const rows = data => Array.isArray(data) ? data : data && Array.isArray(data.results) ? data.results : []
const hasBookingSalesRole = groups => Array.isArray(groups) && groups.some(group => ['sales_manager', 'sales_supervisor', 'general_manager'].includes(group.code))

function flightDuration(departure, arrival) {
  const parse = value => {
    const match = typeof value === 'string' && /^([01]\d|2[0-3]):([0-5]\d)(?::[0-5]\d(?:\.\d+)?)?$/.exec(value)
    return match ? (Number(match[1]) * 60) + Number(match[2]) : null
  }
  const start = parse(departure)
  const end = parse(arrival)
  if (start === null || end === null) return ''
  // The API has clock times only; an earlier arrival is treated as the next day.
  const minutes = (end - start + 1440) % 1440
  const hours = Math.floor(minutes / 60)
  const remainder = minutes % 60
  return hours ? `${hours}h${remainder ? ` ${remainder}m` : ''}` : `${remainder}m`
}

function formatBaggageAllowance(value) {
  if (!['string', 'number'].includes(typeof value) || empty(value)) return '—'
  const amount = Number(value)
  return Number.isFinite(amount) && amount >= 0 ? `${new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(amount)} kg` : '—'
}

function dateTime(value, dateOnly = false) {
  if (!value || !Number.isFinite(new Date(value).getTime())) return ''
  return new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    timeZone: 'Africa/Dar_es_Salaam',
    ...(dateOnly ? {} : { hour: '2-digit', minute: '2-digit' })
  }).format(new Date(value))
}
function deadlineState(value, now) {
  if (!dateTime(value)) return 'unknown'
  const remaining = new Date(value).getTime() - now
  if (remaining <= 0) return 'expired'
  return remaining < 48 * 3600000 ? 'due-soon' : 'normal'
}
function responseError(error, fallback = 'Unable to complete the request') {
  const data = error && error.response && error.response.data
  if (!data) return fallback
  const message = data.details || data.detail || data.error || data.message || data
  if (typeof message === 'string') return message
  return Object.entries(message)
    .map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : String(value)}`)
    .join('; ') || fallback
}
module.exports = { empty, code, label, rows, hasBookingSalesRole, flightDuration, formatBaggageAllowance, dateTime, deadlineState, responseError }
